import { Action, Selector, State, StateContext } from "@ngxs/store";
import { UserStateModel } from "./user-model";
import { User  } from "../../models/user";
import { Injectable } from "@angular/core";
import { Users } from "./user-actions";
import { UserService } from "../../services/user.service";

import { append, patch, removeItem, updateItem } from "@ngxs/store/operators";
import { IUser } from "../../models/user";

@State<UserStateModel>
(
    {
        name: "user",
        defaults: 
        {
            currentUser: undefined,
            users_list: []
        }
    }
)

@Injectable({
    providedIn: 'root'
  })
  export class UserState 
  {

    
    constructor(private _userService: UserService)
    {
    }



    @Selector()
    static currentUser(state: UserStateModel) 
    {
        if(state)
            return state.currentUser;
        return undefined;
    }

    @Selector()
    static users_list(state: UserStateModel)
    {
        return state.users_list;
    }

    @Action([Users.AppLoaded])
    logUserIn(ctx: StateContext<UserStateModel>)
    {
        //Get the user
        this._userService.getMe().subscribe
        (
            (u:User) =>
            {
                ctx.dispatch(new Users.UserLoggedIn({user:u}))
            }
        );
    }

    @Action(Users.UserLoggedIn)
    async sucessfulLogin(ctx: StateContext<UserStateModel>, action: Users.UserLoggedIn)
    {
        //Get the user
        const state = ctx.getState();
        ctx.setState
        (
            {
                ...state,
                currentUser: action.payload.user,
                users_list: action.payload.user ? await this._userService.getAllUsers() : []
            }
        ); 

    }

    @Action(Users.UserInserted)
    async userInserted(ctx: StateContext<UserStateModel>, action: Users.UserInserted)
    {
        ctx.setState
        ( 
            patch<UserStateModel>
            (
                { users_list: append([action.payload.user]) }
            )
        );
    }
   
    @Action(Users.UserUpdated)
    async userUpdated(ctx: StateContext<UserStateModel>, action: Users.UserUpdated)
    {
        //ctx.dispatch(new Users.UserUpdated({user: action.payload.user}));
        var existingState = ctx.getState();
        var user = action.payload.user;
        if(existingState.currentUser && existingState.currentUser.id == action.payload.user.id)
        {
            user = await this._userService.getUser(action.payload.user.id);
            ctx.setState
            (
                patch<UserStateModel>
                (
                    { currentUser: user }
                )
            )
        }
        ctx.setState( patch<UserStateModel>( { users_list: updateItem(user => user.id == action.payload.user.id, user) }))
    }

    @Action(Users.UserDeleted)
    async userDeleted(ctx: StateContext<UserStateModel>, action: Users.UserDeleted)
    {
        ctx.setState
        (
            patch<UserStateModel>
            (
                { users_list: removeItem(user => user.id == action.payload.user.id) }
            )
        )
 
    }

    @Action(Users.UserAssignedEncounter)
    async userAssignedEncounter(ctx: StateContext<UserStateModel>, action: Users.UserAssignedEncounter)
    {
    }

    @Action(Users.UserUnassignedEncounter)
    async userUnassignedEncounter(ctx: StateContext<UserStateModel>, action: Users.UserUnassignedEncounter)
    {
    }
  }
